"use client";

import styles from "styles/components/about-section.module.css";
import { useLanguage } from "hooks/useLanguage";
import { languageBuild } from "lib/language";
import base from "lib/base";
import { useMemo } from "react";

// Dynamic import of DOMPurify only on client side
let DOMPurify;
if (typeof window !== "undefined") {
  DOMPurify = require("dompurify");
}

const AboutSection = ({ statistics, info }) => {
  const { language } = useLanguage();

  const title = languageBuild(info, "aboutTitle", language) || "Gerelt Publish";
  const content =
    languageBuild(info, "aboutShortDescription", language) ||
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.";

  const safeContent = useMemo(() => {
    // Only sanitize on client side
    if (typeof window !== "undefined" && DOMPurify) {
      return DOMPurify.sanitize(content);
    }
    // Return plain content on server side (Next.js will re-render on client)
    return content;
  }, [content]);

  // Handle images from info.aboutImages or info.aboutPicture or fallbacks
  // Info object might be { core: {...}, translation: {...} } or a flat object
  const core = info?.core || info || {};

  const cdn = (base.cdnUrl || "").replace(/\/+$/, ""); // Remove trailing slashes
  const buildPhotoCardUrl = (path) => {
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path;
    return `${cdn}/450/${path.replace(/^\/+/, "")}`;
  };

  const aboutImages = core?.aboutImages || [];
  const aboutPicture = core?.aboutPicture;

  const img1 =
    aboutImages && aboutImages[0]
      ? buildPhotoCardUrl(aboutImages[0])
      : aboutPicture
        ? buildPhotoCardUrl(aboutPicture)
        : "/assets/img/about_img.png";

  const img2 =
    aboutImages && aboutImages[1]
      ? buildPhotoCardUrl(aboutImages[1])
      : "/assets/img/image-3.png";

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className={styles.imageArea}>
              <div className={`${styles.photoCard} ${styles.photo1}`}>
                <img src={img1} alt="Team" className={styles.img} />
              </div>
              <div className={`${styles.photoCard} ${styles.photo2}`}>
                <img src={img2} alt="Book" className={styles.img} />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className={styles.content}>
              <h2 className={styles.title}>{title}</h2>
              <p
                className={styles.text}
                dangerouslySetInnerHTML={{ __html: safeContent }}
              />
              <div className={styles.stats}>
                {statistics && statistics.length > 0 ? (
                  statistics.map((stat, i) => (
                    <div className={styles.statItem} key={i}>
                      <span className={styles.statNumber}>
                        {stat.allCount}+
                      </span>
                      <span className={styles.statLabel}>
                        {languageBuild(stat, "name", language)}
                      </span>
                    </div>
                  ))
                ) : (
                  <>
                    <div className={styles.statItem}>
                      <span className={styles.statNumber}>1K+</span>
                      <span className={styles.statLabel}>Уншигч</span>
                    </div>
                    <div className={styles.statItem}>
                      <span className={styles.statNumber}>15+</span>
                      <span className={styles.statLabel}>Хэвлэл</span>
                    </div>
                    <div className={styles.statItem}>
                      <span className={styles.statNumber}>100+</span>
                      <span className={styles.statLabel}>Орчуулга</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
